// Description: Page to handle the login with the facebook
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import { useEffect } from 'react';

// Render The Page
const FacebookLogin = () => {
  useEffect(() => {
    // Inicializa o SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1003447588254067',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v22.0'
      });
    };

    // Carrega o SDK
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  const handleLogin = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          console.log('Login bem-sucedido:', response.authResponse);
          alert('Token: ' + `${response.authResponse.accessToken}`);
        } else {
          alert('Login cancelado ou não autorizado.');
        }
      },
      {
        scope: 'whatsapp_business_management,whatsapp_business_messaging'
      }
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>Teste de Login com Facebook</h1>
      <button onClick={handleLogin}>Entrar com Facebook</button>
    </div>
  );
};

export default FacebookLogin;